import { useCallback, useEffect, useRef } from 'react';

interface IReturnedObject {
  getMistakesCount: () => number;
  addOneMistake: () => void;
  resetMistakes: () => void;
}

export default function useMistakesCount(
  initialValue: number,
  resetRefs: any[]
): IReturnedObject {
  const attemptsCountRef = useRef<number>(initialValue);

  // Stable, like its two siblings. It is read inside effect dependency arrays,
  // and a fresh identity on every render re-runs those effects — in
  // ArrangeWordsItem that re-reported a finished answer on any later render.
  const getMistakesCount = useCallback(() => attemptsCountRef.current, []);

  const addOneMistake = useCallback(() => {
    attemptsCountRef.current += 1;
  }, []);

  const resetMistakes = useCallback(() => {
    attemptsCountRef.current = initialValue;
  }, [initialValue]);

  useEffect(() => {
    resetMistakes();
    /* eslint-disable-next-line */
  }, [...resetRefs, resetMistakes]);

  return {
    getMistakesCount,
    addOneMistake,
    resetMistakes
  };
}
